// extracted by mini-css-extract-plugin
export default {"wrapper":"PageNotFound_wrapper__+qXsN","buttonsRow":"PageNotFound_buttonsRow__yA+E9"};